import React from 'react'

export const TimeSyncContext = React.createContext()
